var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHello(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 384,
    width: 525,
    style: {
      display: "block"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(262.5, 192)"
  }, /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(77, 81)",
    fontSize: "64px"
  }, "Hello"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(63, 1)",
    fontSize: "40px"
  }, "Marhaba"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-94, 58) rotate(90)",
    fontSize: "40px"
  }, "Hola"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-2, 92) rotate(-90)",
    fontSize: "37px"
  }, "Bonjour"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(169, 110) rotate(-90)",
    fontSize: "29px"
  }, "Hallo"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(164, 27) rotate(-90)",
    fontSize: "25px"
  }, "Ol\xE1"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-30, 39) rotate(-90)",
    fontSize: "22px"
  }, "Zdravo"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#960200",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-116, 18) rotate(90)",
    fontSize: "22px"
  }, "Selamat"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-60, 101) rotate(90)",
    fontSize: "22px"
  }, "\u4F60\u597D"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#854fee",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-122, 33) rotate(-90)",
    fontSize: "20px"
  }, "Salam"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#960200",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-113, 137)",
    fontSize: "20px"
  }, "Buon giorno"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#854fee",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(41, -34)",
    fontSize: "20px"
  }, "Habari"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-93, -44)",
    fontSize: "18px"
  }, "Kon ta bai"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(17, 16)",
    fontSize: "18px"
  }, "\u03B3\u03B5\u03B9\u03B1 \u03C3\u03BF\u03C5"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#854fee",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(134, -69) rotate(-90)",
    fontSize: "18px"
  }, "\uC548\uB155\uD558\uC138\uC694"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(89, 104) rotate(-90)",
    fontSize: "18px"
  }, "Salut"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#960200",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-116, -63)",
    fontSize: "18px"
  }, "Namaste"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-49, -9) rotate(-90)",
    fontSize: "18px"
  }, "Halo"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-14, -54)",
    fontSize: "18px"
  }, "Salom"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#960200",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-121, 95) rotate(90)",
    fontSize: "18px"
  }, "Talofa"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-145, 73) rotate(-90)",
    fontSize: "16px"
  }, "Senga yai"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(87, -68) rotate(-90)",
    fontSize: "16px"
  }, "Tungjatjeta"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#854fee",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(19, 107) rotate(90)",
    fontSize: "16px"
  }, "Barev"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#854fee",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(24, -71)",
    fontSize: "16px"
  }, "Namaskar"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(87, 30)",
    fontSize: "16px"
  }, "Zdravei"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#854fee",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(109, -87) rotate(-90)",
    fontSize: "16px"
  }, "Kuzu zangpo"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(173, -71)",
    fontSize: "16px"
  }, "Dumela"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#960200",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(44, 107) rotate(90)",
    fontSize: "16px"
  }, "\u0412\u0456\u0442\u0430\u044E"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(172, -26) rotate(90)",
    fontSize: "16px"
  }, "Kia orana"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#960200",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-66, -100) rotate(90)",
    fontSize: "16px"
  }, "Dobr\xFD den"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-60, 35) rotate(90)",
    fontSize: "16px"
  }, "Hej"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-163, 29)",
    fontSize: "16px"
  }, "Tervist"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-35, -120) rotate(-90)",
    fontSize: "16px"
  }, "Teanast\xEBll\xEBn"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-44, -16) rotate(90)",
    fontSize: "16px"
  }, "Moi"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#960200",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(189, -10) rotate(90)",
    fontSize: "16px"
  }, "Gamardjobat"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-140, -2)",
    fontSize: "16px"
  }, "Aluu"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-81, -12) rotate(-90)",
    fontSize: "16px"
  }, "HHola"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(61, -101) rotate(90)",
    fontSize: "16px"
  }, "Bok"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#854fee",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-84, -112) rotate(90)",
    fontSize: "16px"
  }, "J\xF3 napot"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(107, 111) rotate(90)",
    fontSize: "16px"
  }, "Haileo"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#960200",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-124, -81)",
    fontSize: "16px"
  }, "Shalom"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(24, -109) rotate(90)",
    fontSize: "16px"
  }, "Sal\xE2m"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-178, 122) rotate(-90)",
    fontSize: "16px"
  }, "G\xF3\xF0an daginn"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-163, -19)",
    fontSize: "16px"
  }, "\u3053\u3093\u306B\u3061\u306F"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(43, -119) rotate(90)",
    fontSize: "16px"
  }, "Kandisiz"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(141, 121) rotate(-90)",
    fontSize: "16px"
  }, "Sua sdei"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-139, -119) rotate(-90)",
    fontSize: "16px"
  }, "Mauri"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(187, 99) rotate(-90)",
    fontSize: "16px"
  }, "Bariza djioni"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(180, -87)",
    fontSize: "16px"
  }, "Sabaidee"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(198, 97) rotate(90)",
    fontSize: "16px"
  }, "A`yubowan"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(61, 135) rotate(90)",
    fontSize: "16px"
  }, "Laba diena"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(103, 133) rotate(-90)",
    fontSize: "16px"
  }, "Mo\xEFen"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(0, -106) rotate(90)",
    fontSize: "16px"
  }, "Sveiki"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(126, -143)",
    fontSize: "16px"
  }, "Manao ahoana"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-195, 131) rotate(-90)",
    fontSize: "16px"
  }, "Yokwe"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#854fee",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-166, -82) rotate(-90)",
    fontSize: "16px"
  }, "Mingalarba"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(211, -17) rotate(90)",
    fontSize: "16px"
  }, "Sain baina uu"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(199, -103)",
    fontSize: "16px"
  }, "Bongu"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(224, 99) rotate(-90)",
    fontSize: "16px"
  }, "Kihineth"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-23, -132) rotate(90)",
    fontSize: "16px"
  }, "Muribwanji"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(15, 115) rotate(-90)",
    fontSize: "16px"
  }, "Bozo"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-90, -146) rotate(-90)",
    fontSize: "16px"
  }, "Whataway"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#960200",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(182, 170)",
    fontSize: "16px"
  }, "Faka lofa lahi atu"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-185, 12)",
    fontSize: "16px"
  }, "Adaab"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#960200",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-195, -88) rotate(90)",
    fontSize: "16px"
  }, "Dzie\u0144 dobry"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-107, -105) rotate(-90)",
    fontSize: "16px"
  }, "Alii"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-212, 74) rotate(-90)",
    fontSize: "16px"
  }, "\u0417\u0434\u0440\u0430\u0432\u0441\u0442\u0432\u0443\u0439\u0442\u0435"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(227, 14) rotate(90)",
    fontSize: "16px"
  }, "God dag"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(144, -43) rotate(90)",
    fontSize: "16px"
  }, "\u017Divijo"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-79, 157)",
    fontSize: "16px"
  }, "Dobr\xFD de\u0148"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#854fee",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(71, -161)",
    fontSize: "16px"
  }, "Maalim wanaqsan"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-212, -83) rotate(90)",
    fontSize: "16px"
  }, "Sawatdi"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-122, -144) rotate(-90)",
    fontSize: "16px"
  }, "Taloha"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#854fee",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(231, -143) rotate(90)",
    fontSize: "16px"
  }, "Malo e lelei"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(207, -153) rotate(-90)",
    fontSize: "16px"
  }, "Merhaba"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#F45B69",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(-192, 55) rotate(-90)",
    fontSize: "16px"
  }, "Pryvit"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#4458dc",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(43, -54)",
    fontSize: "16px"
  }, "Ch\xE0o"), /*#__PURE__*/React.createElement("text", {
    cursor: "default",
    fill: "#52489C",
    fontFamily: "Century Gothic,CenturyGothic,AppleGothic,Oxygen",
    fontStyle: "normal",
    fontWeight: "bold",
    textAnchor: "middle",
    transform: "translate(242, 90) rotate(90)",
    fontSize: "16px"
  }, "Malo le kataki"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHello);
export default __webpack_public_path__ + "static/media/Hello.3fe1572eeed9a58f0aa9b8ca0ef86fa1.svg";
export { ForwardRef as ReactComponent };